module.exports = __webpack_public_path__ + "static/media/Combles_amenages_11_pv_RT_MAX_annotee.4c30f929.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Combles_amenages_11_pv_RT_MAX_annotee.jpg
// module id = 1154
// module chunks = 0